// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0e1027',
    },
    secondary: {
      main: '#b29600',
    },
    background: {
      default: '#FFF8E1',
    },
  },
  typography: {
    // Customize typography as needed
  },
});

export default theme;
